module.exports = __webpack_public_path__ + "static/media/paginate-next.47aa728c.svg";